import { render, staticRenderFns } from "./TotalEvents.vue?vue&type=template&id=41c7bd4d&scoped=true"
import script from "./TotalEvents.vue?vue&type=script&lang=js"
export * from "./TotalEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c7bd4d",
  null
  
)

export default component.exports